/**
 * Gate identifiers used to enforce event ordering constraints:
 * - `session`: analytics allowed only inside active user session
 * - `player`: player-scoped events only after player open
 * - `play`: stop events only after corresponding start
 */
export const seeds = {
  session: Symbol('session_gate'),
  player: Symbol('player_gate'),
  play: Symbol('play_gate'),
}

/**
 * Queue gate descriptor used by shunting queue to validate/transition state.
 */
export class Gate {
  public seed: symbol
  private action: 2 | 1 | 0

  constructor(seed: symbol, action: 2 | 1 | 0) {
    this.seed = seed
    this.action = action
  }

  static Opens(seed: symbol): Gate {
    return new Gate(seed, 1)
  }

  static Closes(seed: symbol): Gate {
    return new Gate(seed, 0)
  }

  static Uses(seed: symbol): Gate {
    return new Gate(seed, 2)
  }

  get opens(): boolean {
    return this.action === 1
  }

  get closes(): boolean {
    return this.action === 0
  }

  get uses(): boolean {
    return this.action === 2
  }

  toString(): string {
    const description = Gate.toString(this.seed)
    return `${this.opens ? '□' : this.closes ? '■' : '△'}${description}`
  }

  static toString(seed: symbol): string {
    return seed.description || '~'
  }
}
